import React, { useRef, useState } from 'react'
import axios from '../api/axios';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ENDPOINT_ACCOUNT_RESET_PASSWORD } from '../Config';
import usePageTitle from '../hooks/usePageTitle';

function ForgotPassword() {
    usePageTitle('Forgot Password');
    const [errMsg, setErrMsg] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const emailRef = useRef();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSubmitting(true);
            const response = await axios.post(ENDPOINT_ACCOUNT_RESET_PASSWORD,
                JSON.stringify({ email: email }), {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            if (response.status === 200) {
                setEmailSent(true);
            }
        } catch (err) {
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setErrMsg(err.response.data);
            } else {
                setErrMsg('Login Failed');
            }
            emailRef.current.focus();
        } finally {
            setSubmitting(false);
        }
    }


    return (
        <section>
            <div className="row d-flex justify-content-center">
                <div className="col-md-4">
                    <h1 className='mb-5'>Forgot Password</h1>
                    <form onSubmit={handleSubmit}>
                        {emailSent ?
                            <>
                                <p className='alert alert-success h6'>
                                    <div className='d-flex align-items-center'>
                                        <FontAwesomeIcon icon={faCheckCircle} size='3x' className='me-2'></FontAwesomeIcon>
                                        <span>
                                            Instructions for changing your password have been sent to your e-mail address.
                                        </span>
                                    </div>
                                </p>
                            </>
                            :
                            <>
                                <p className='text-muted'>
                                    <FontAwesomeIcon icon={faInfoCircle} fixedWidth></FontAwesomeIcon> Enter the email address you registered with, and we'll email you a link to reset your password.
                                </p>
                                {errMsg &&
                                    <p className='alert alert-danger' aria-live="assertive">{errMsg}</p>
                                }
                                <div className="mb-3">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="email"
                                        ref={emailRef}
                                        autoComplete="off"
                                        onChange={(e) => setEmail(e.target.value)}
                                        value={email}
                                        required
                                    />
                                </div>
                                <div className="text-center">
                                    <button className="btn btn-primary" disabled={submitting}>
                                        {submitting && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} Send
                                    </button>
                                </div>
                            </>
                        }
                    </form>
                    <hr />
                    <p>
                        Already have account? <Link to="/login">Sign In</Link>
                    </p>
                    <p>
                        Need an account? <Link to="/register">Sign Up</Link>
                    </p>
                </div>
            </div>

        </section>
    )
}

export default ForgotPassword
